export default __webpack_public_path__ + "static/media/093-undo.d090fb6a.png";